import SaleData from "./SaleData";
import localDB from "./localDB";

let GLOBAL = require('./globals');

const PrinterData = {
    printInvoice(id, extra=null, items) {
        return new Promise((resolve, reject) => {
            let socket = new WebSocket(GLOBAL.WS_PRINTER);
            let print_settings = localDB.get('printer_settings');
            socket.onerror = () => {
                socket.close();
                reject(1)
            };
            socket.onopen= function() {
                if (!print_settings) {
                    reject(1);
                }else{
                    SaleData.getSaleInvoice(id, items).then((res)=>{
                        if(res.hasOwnProperty('id')){
                            let print_data = {
                                data: res,
                                paper: print_settings.paper,
                                printer: print_settings.printer,
                                type: 'invoice',
                                extra: extra
                            };
                            socket.send(JSON.stringify(print_data));
                            resolve("Imprimiendo...")
                        }else{
                            reject(2);
                        }
                    });
                }
            };
        })
    },

    printOrder(id, items) {
        return new Promise((resolve, reject) => {
            let socket = new WebSocket(GLOBAL.WS_PRINTER);
            let print_settings = localDB.get('printer_settings');
            socket.onerror = () => {
                socket.close();
                reject(1)
            };
            socket.onopen = function () {
                if (!print_settings) {
                    reject(1);
                } else {
                    SaleData.getOrder(id, items).then((res) => {
                        if (res.order.items.length > 0 ) {
                            let print_data = {
                                data: res,
                                paper: print_settings.paper,
                                printer: print_settings.printer,
                                type: 'order'
                            };
                            socket.send(JSON.stringify(print_data));
                            resolve("Imprimiendo...")
                        } else {
                            reject(2);
                        }
                    });
                }
            };
        })
    },
    printTicket(data, print_type, extra=null) {
        return new Promise((resolve, reject) => {
            let socket = new WebSocket(GLOBAL.WS_PRINTER);
            let print_settings = localDB.get('printer_settings');
            socket.onerror = () => {
                socket.close();
                reject(1)
            };
            socket.onopen = function () {
                if (!print_settings) {
                    reject(1);
                } else {
                    let print_data = {
                        paper: print_settings.paper,
                        printer: print_settings.printer,
                        data: data,
                        type: print_type,
                        extra: extra
                    }
                    socket.send(JSON.stringify(print_data));
                    resolve("Imprimiendo...")
                }
            };
        })
    },

    printBox(data, extra=null) {
        return new Promise((resolve, reject) => {
            let socket = new WebSocket(GLOBAL.WS_PRINTER);
            let print_settings = localDB.get('printer_settings');
            socket.onerror = () => {
                socket.close();
                reject(1)
            };
            socket.onopen= function() {
                if (!print_settings) {
                    reject(1);
                }else{
                    let print_data = {
                        data,
                        paper: print_settings.paper,
                        printer: print_settings.printer,
                        type: 'box',
                        extra: extra
                    };
                    socket.send(JSON.stringify(print_data));
                    resolve("Imprimiendo...");
                }
            };
        })
    },
};

export default PrinterData;


// WEBPACK FOOTER //
// ./src/data/PrinterData.js